import * as userResource from 'resources/user/hooks';
import * as companyResource from 'resources/company/hooks';

const useCurrentCompany = () => {
  const { data: user } = userResource.useCurrentUser();
  const { data: company } = companyResource.useCompany(user?.company_id, { enabled: !!user });

  return { company };
};

export default useCurrentCompany;
